module.exports = __webpack_public_path__ + "@/assets/img/settings.93b2874a.svg";